<template>
  <VDropdown v-model="selected" size="xs" :options="options as DropdownOption[]" container-classes="p-0">
    <template #current-single="{ item }">{{ item.name }}</template>
    <template #option="{ item }">
      <span :class="`${(item as DropdownOption).classes} p-2 pr-24 block pointer-events-none font-light`">{{ item.name }}</span>
    </template>
  </VDropdown>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'

type DropdownOption = {
  id: number
  name: string
  classes: string
}

const props = defineProps({
  value: {
    type: Number as PropType<number>,
    required: true,
  },
  options: {
    type: Array as PropType<DeepReadonly<DropdownOption[]>>,
    default: () => [
      { id: 400, name: 'Headline', classes: 'text-3xl' },
      { id: 300, name: 'Subheading', classes: 'text-2xl' },
      { id: 200, name: 'Body', classes: 'text-xl' },
      { id: 100, name: 'Subtitle', classes: 'text-lg' },
    ],
  },
})

const emit = defineEmits(['input'])

const selected = ref<DropdownOption | null>(null)

onMounted(() => {
  selected.value = props.options.find(({ id }) => id === props.value) ?? null
})

watch(selected, value => {
  if (!value) return
  emit('input', value.id)
})

watch(
  () => props.value,
  () => {
    selected.value = props.options.find(({ id }) => id === props.value) ?? null
  },
)
</script>
